import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { MarketingInfluenceComponent } from './containers/container.component';

const routes: Routes = [
  {
    path: '',
    component: MarketingInfluenceComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class MarketingInfluenceRoutingModule {
}
